export const SUPABASE_IMAGE_BASE_URL = 'https://image.pokemonpocket.fr/';

export const TINYMCE_API_KEY = '60ffbqxt2oiox8o48g7nfngtc1fi30px5lg2kc0p6vqsg19i';

